import { IOAuthUser } from "@/api_framework/api_modals/FirebaseLogin";
import { IStaffRolePermissionData } from "@/api_framework/api_modals/UserRoles";
import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { IAuthReducerState, IUserAuthorization } from "./reducer_interface";

// Define the initial state using that type
const intialRootState: IAuthReducerState = {
  userRole: null,
  userLoginInfo: null,
  vms_user_id: null,
  userPermissions: null,
  user: null,
  authorization: {
    isValid: false,
    accessToken: "",
  },
};

export const authStateSlice = createSlice({
  name: "authState",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState: intialRootState,
  reducers: {
    RESET_AUTH_STATE: () => {
      return intialRootState;
    },
    setUserPermissions: (state, action: PayloadAction<IStaffRolePermissionData>) => {
      state.userPermissions = action.payload;
    },
    setUserRole: (state, action: PayloadAction<{ data: any }>) => {
      state.userRole = action.payload.data;
    },
    setUserLoginInfo: (state, action: PayloadAction<{ data: any }>) => {
      state.userLoginInfo = action.payload.data;
    },
    setVMSuserId: (state, action: PayloadAction<{ data: any }>) => {
      state.vms_user_id = action.payload.data;
    },
    setUserValid: (state, action: PayloadAction<{ isValid: boolean }>) => {
      state.authorization.isValid = action.payload.isValid;
    },
    setOAuthUser: (state, action: PayloadAction<IOAuthUser>) => {
      state.user = action.payload;
    },
    setAuthorization: (state, action: PayloadAction<IUserAuthorization>) => {
      state.authorization = action.payload;
    },
  },
});

export const {
  setOAuthUser,
  setAuthorization,
  setUserValid,
  setUserRole,
  setUserPermissions,
  RESET_AUTH_STATE,
  setUserLoginInfo,
  setVMSuserId,
} = authStateSlice.actions;

export default authStateSlice.reducer;
